// extracted by mini-css-extract-plugin
export default {"wrapper":"PnL_wrapper__syk96","title":"PnL_title__CKUwf","graph":"PnL_graph__7kGaE"};